import React from 'react'
import classes from "./LandingPageMainCard.module.css"
const LandingPageMainCard = (props) => {
  return (
    <div className={classes.card}>{props.children}</div>
  )
}

export default LandingPageMainCard